export const getDestinationTenantFromUrl = (activeTenantId?: string) => {
  if (typeof window !== 'undefined') {
    const destinationTenantId = window.location.pathname.split('/')[1];
    if (!destinationTenantId && !activeTenantId) {
      throw new Error(
        'getDestinationTenantFromUrl Should not be called until we have a destination tenant',
      );
    }
    if (destinationTenantId === 'join') {
      throw new Error('Should not use join as a tenant destination');
    }
    if (destinationTenantId === 'fromtemplate') {
      throw new Error('Should not use join as a tenant destination');
    }
    if (destinationTenantId === 'share') {
      throw new Error('Should not use share as a tenant destination');
    }
    if (destinationTenantId === 'discover' && activeTenantId) {
      return activeTenantId;
    }
    if (destinationTenantId === 'feedback' && activeTenantId) {
      return activeTenantId;
    }
    if (destinationTenantId === 'ai' && activeTenantId) {
      return activeTenantId;
    }
    if (destinationTenantId === 'generators' && activeTenantId) {
      return activeTenantId;
    }
    if (activeTenantId) {
      return activeTenantId;
    }
    return destinationTenantId;
  }
};

export const isBrowser = () => {
  if (typeof window !== 'undefined') {
    // Client-side-only code
    return true;
  }
  return false;
};
